var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useState } from 'react';

import { useLoaderData, useRevalidator } from 'react-router';
import { Translate, I18NLinkV2 as I18NLink, t } from "../../../../I18N";
import { useSetAtom } from 'jotai';
import { notificationAtom } from "../../../atoms";
import { Table } from "../../../Components/UI/Table/Table";
import { Button } from "../../../Components/UI/Button";
import * as templatesApi from "../../../api/templates";
import { RequestParams } from "../../../../utils/RequestParams";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";


import { columns } from "./components/TemplatesTableComponents";
import { DeleteTemplatesConfirmationModal } from "./components/DeleteTemplatesConfirmationModal";


const templatesLoader =
(headers) =>
async () => {
  const templates = await templatesApi.get(headers);
  const templateIds = templates.map((template) => template._id);
  const entityCounts = await templatesApi.checkTemplatesEntityCount(headers, templateIds);
  return templates.map((template) => {
    const reasons = [];
    if (template.default) {
      reasons.push(t('System', 'A default template cannot be deleted.', null, false));
    }
    if (entityCounts[template._id] > 0) {
      reasons.push(
        t(
          'System',
          'This template is in use by existing entities and cannot be deleted.',
          null,
          false
        )
      );
    }
    if (template.synced) {
      reasons.push(t('System', 'Synced templates cannot be deleted.', null, false));
    }

    const disableRowSelection = reasons.length > 0 ? reasons.join(' ') : undefined;

    return _objectSpread(_objectSpread({},
    template), {}, {
      rowId: template._id,
      translation: template.name,
      entityCount: entityCounts[template._id] || 0,
      disableRowSelection });

  });
};

const Templates = () => {
  const templates = useLoaderData();
  const [selected, setSelected] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);

  const hasSyncedTemplates = templates.some((template) => template.synced);

  const handleSetDefault = async (row) => {
    try {
      await templatesApi.setDefault(new RequestParams({ _id: row._id }));
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Default template set successfully.")
      });
      await revalidator.revalidate();
    } catch (e) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error setting default template")
      });
    }
  };

  const handleDeleteClick = async () => {
    setShowDeleteModal(true);
  };

  const handleDelete = async (templatesToDelete) => {
    setShowDeleteModal(false);
    try {
      await Promise.all(
        templatesToDelete.map(async (template) =>
        templatesApi.remove(new RequestParams({ _id: template._id }))
        )
      );
      setSelected([]);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Template(s) deleted successfully.")
      });
      await revalidator.revalidate();
    } catch (e) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error deleting template(s)")
      });
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto", "data-testid": "settings-templates" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Templates" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns(handleSetDefault, hasSyncedTemplates),
      data: templates,
      enableSelections: true,
      onChange: ({ selectedRows }) => setSelected(Object.keys(selectedRows)),
      defaultSorting: [{ id: 'name', desc: false }],
      className: "bg-white" }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0,
    selected.length === 0 && /*#__PURE__*/
    _jsx(I18NLink, { to: "/settings/templates/new" }, void 0, /*#__PURE__*/
    _jsx(Button, { color: "primary" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add template")
    )
    ),

    selected.length > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { color: "error", onClick: handleDeleteClick }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx("span", { className: "text-gray-700" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selected.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"), ' ',
    templates.length
    )
    )

    )
    )
    ), /*#__PURE__*/
    _jsx(DeleteTemplatesConfirmationModal, {
      open: showDeleteModal,
      onAccept: handleDelete,
      onCancel: () => setShowDeleteModal(false),
      templates: templates.filter((template) => selected.includes(template._id)) }
    )
    ));

};

export { Templates, templatesLoader };